<template>
  <div class="login-container">
    <el-form ref="form" :model="form" label-width="80px" class="login-form">
      <div class="title-container">
        <span>{{ title }}</span>
      </div>
      <el-form-item label="用户名">
        <el-input v-model="form.userName" clearable></el-input>
      </el-form-item>
      <el-form-item label="密码">
        <el-input v-model="form.password" type="password" clearable @keydown.enter.native="onSubmit"></el-input>
      </el-form-item>
      <div>
        <el-button type="primary" @click="onSubmit" style="width: 100%;" size="normal" v-html="loginButtonText"
          :loading="isLoading"></el-button>
      </div>
      <div style="text-align: right;">
        <el-button type="text" @click="goToRegist">注册用户</el-button>
      </div>
      <div class="footer">
        <span v-html="footer"></span>
      </div>
    </el-form>
  </div>
</template>

<script>
import { login } from '@/util/request.js'

export default {
  name: 'Login',
  data() {
    return {
      title: '高清地图拼接系统',
      msg: 'jayhuang',
      footer: 'powered by txzmap.com<br> from 2024-11-13',
      loginButtonText: '登&emsp;陆',
      isLoading: false,
      form: {
        userName: '',
        password: ''
      }
    }
  },
  methods: {
    onSubmit() {
      this.isLoading = true
      login(this.form).then(data => {
        if (data.resultCode === 1) {
          //登陆成功
          let user = data.result
          this.$store.commit('setUser', user)
          let info = '登陆成功'
          if (this.$store.getters.vipIsAvailable) {
            info = '欢迎回来，尊敬的vip用户'
          }
          this.$message.success(info)
          this.$router.push('/map')

        } else {
          this.$message.error('用户名或密码错误')
        }
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
      })
    },
    goToRegist() {
      this.$router.push('/regist')
    }
  }
}
</script>
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: #2d3a4b;
  overflow: hidden;
}

.login-form {
  position: relative;
  width: 500px;
  max-width: 100%;
  padding: 160px 35px 0;
  margin: 0 auto;
  overflow: hidden;

  .el-form-item {
    border: 1px solid hsla(0, 0%, 100%, .1);
    background: rgba(0, 0, 0, .1);
    border-radius: 5px;
    color: #454545;
  }

  input {
    background: transparent;
    border: none;
    color: white;
  }
}

.footer {
  color: #bbbaba;
  padding-top: 10px;

}

.title-container {
  color: white;
  padding-bottom: 10px;
  line-height: 2em;
  font-size: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue